module.exports = __webpack_public_path__ + "img/yizhanshi4.dcd4a714.png";